import React, { useContext } from "react";
import { TodosContext } from "../providers/TodosProvider";
import "../css/todos.scss";
import { todoers } from "../popData";
import BookmarkIcon from "@mui/icons-material/Bookmark";

const TodoIndicators = () => {
  const { todos, toggleTodosDrawer } = useContext(TodosContext);

  // Separate todos by who they are intended for.
  let indicators = {};
  todos.forEach(({ isComplete, intendedFor }) => {
    if (!isComplete) {
      if (indicators.hasOwnProperty(intendedFor)) {
        indicators[intendedFor].count++;
      } else {
        indicators[intendedFor] = {
          count: 1,
          initials: todoers[intendedFor].initials,
          colourStyle: todoers[intendedFor].colourStyle,
        };
      }
    }
  });

  function openMyTodos(forId) {
    // When todo indicator/bookmark selected, set todo filter to bookmark id
    // and open the todos drawer.
    window.sessionStorage.setItem(
      "todo-filters",
      JSON.stringify({
        intendedFor: [forId],
        orderBy: [],
        sortBy: [],
      })
    );

    toggleTodosDrawer(true);
  }

  return (
    <div className="todo-indicators">
      {Object.keys(indicators).map((forId) => {
        let { initials, colourStyle } = indicators[forId];
        return (
          <button
            className="todos-bookmark-btn"
            key={forId}
            onClick={() => openMyTodos(forId)}
          >
            <div className="todo-bookmark">
              <BookmarkIcon style={{ fill: colourStyle }} />
              <p className="label">{initials}</p>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default TodoIndicators;
